import { ErrorPage } from "./error-page";

const description =
  "서버 점검 또는 예상치 못한 부하로 인해 현재 서버 상태가 일시적으로 요청을 처리할 수 없습니다. 담당 팀에 연락하여 서비스 복구를 위해 노력하고 있습니다.";

export function NotFoundPage() {
  return (
    <ErrorPage
      code="Error 404"
      title="Not Found"
      description={description}
      illustration="not-found"
    />
  );
}
